<template>
  <div class="card-hour">
    <div class="card-hour__text">{{ formattedTime }} hrs</div>
    <i class="card-hour__check material-icons">check</i>
  </div>
</template>

<script>
export default {
  name: 'CardHour',
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  computed: {
    formattedTime() {
      return this.data.appointment_time.substring(
        0,
        this.data.appointment_time.length - 3,
      );
    },
  },
};
</script>

<style></style>
